import { projectDataType } from ".";

const theHarmData: projectDataType = {
  path: "theharm",
  title: "The Harm of Coming Into Existence",
  coverImage:
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684541479/Art-Site/theHarm/theharm-still-05_zh4ceq.jpg",
  description:
    "A music video for the song The Harm of Coming into Existence by ambient musician Richard Cruz.",
  year: 2016,
  videos: ["https://vimeo.com/89466762"],
  projectPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684541479/Art-Site/theHarm/theharm-still-05_zh4ceq.jpg",
  ],
};

export default theHarmData;
